import { useNavigate, useParams } from "react-router-dom";
import { DataTable } from "../../../components/data-table";
import { useEffect, useState } from "react";
import { dataDecrypt, encrypt } from "../../../app/utility/encryption-helper";
import { ApisService } from "../../../app/core/apis.service";
import moment from "moment";
import { TransactionInvoicesGridCols } from "./data-grid-cols";
import { getMonthStartAndEndDates } from "../../../app/utility/monthStartEndDate";

export const TransactionInvoices = () => {
    const params = useParams();
    const navigate = useNavigate();
    // const [inputValue, setInputValue] = useState("");
    const { startDate, endDate } = getMonthStartAndEndDates();
    const [loading, setLoading] = useState<boolean>(false);
    const [invoiceData, setInvoiceData] = useState<any>();
    const [fromDate, setFromDate] = useState<any>(startDate);
    const [toDate, setToDate] = useState<any>(endDate);
    const initialPayload = { buId: params.org, filters: { limit: 10, page: 0, DateFrom: startDate, DateTo: endDate } }
    const [pageCount, setPageCount] = useState(initialPayload);

    useEffect(() => {
        getRetailInvoices(initialPayload);
    }, [])
    async function getRetailInvoices(data: any): Promise<void> {
        setLoading(true);
        try {
            let encrytedData = encrypt(JSON.stringify(data));
            const res = await ApisService.transactionApi("findBuInvoicesByBuList", encrytedData);
            const TransactionInvoiceData = JSON.parse(dataDecrypt(res.data.data));
            const retailerData = TransactionInvoiceData;
            retailerData?.results.forEach((el: any) => {
                el.date = moment(el.created_dt).format("DD-MM-YYYY");
                el.buyer_name = el.buyer.name;
                // el.seller_name = el.seller.name;
                el.contact = el.buyer.contact_number;
            })
            setInvoiceData(retailerData);
            setLoading(false);
        }
        catch (error) {
            setLoading(false);
        }
    }

    // const handleChange = (e: any) => {
    //     let payload = { buId: params.org, filter: { name: e.target.value } };
    //     getRetailInvoices(payload);
    //     setInputValue(e.target.value);
    // }


    const handleClose = () => {
        // setInputValue("");
        setFromDate(startDate);
        setToDate(endDate);
        getRetailInvoices(initialPayload);
    }

    const searchData = () => {
        let payload = { buId: params.org, filters: { DateFrom: fromDate, DateTo: toDate } };
        getRetailInvoices(payload);
    }

    const selectFromDate = (e: any) => {
        setFromDate(e.target.value);
    }

    const selectToDate = (e: any) => {
        setToDate(e.target.value)
    }

    const onSelectPaginator = (data: any) => {
        const pageData = { ...pageCount, page: data };
        let payload = { buId: params.org, filters: { limit: pageData.filters.limit, page: data ,DateFrom: fromDate, DateTo: toDate } }
        setPageCount(payload);
        getRetailInvoices(payload);
    };

    const onActions = (data: any) => {
        if(data?.type==="view"){
            navigate(`/dashboard/organizations/org-details/${params.org}/transaction/${data?.data?._id}/view`)
        }
    }
    return (
        <div>
            <div className="row">
                <div className="col-12 px-0">
                    <h5 className="mt-3 mb-2 fw-bold">Transaction Invoices</h5>
                    {/* <input type="text" className="form-control rounded-pill" value={inputValue} onChange={handleChange} placeholder="Search invoice by customer name" /> */}
                    <div className="row mt-2">
                        <div className="col-md-5 mb-2">
                            <input type="date" className="form-control" value={fromDate} onChange={selectFromDate} />
                        </div>
                        <div className="col-md-5 mb-2">
                            <input type="date" className="form-control" value={toDate} min={fromDate} onChange={selectToDate} />
                        </div>
                        <div className="col-md-1 mb-2"><button className="form-control primary-bg text-white" onClick={searchData}>Search</button></div>
                        <div className="col-md-1 mb-2"><button className="form-control primary-bg text-white" onClick={handleClose}>Clear</button></div>
                    </div>
                    {loading && (
                        <div className="text-center p-5"><div className="spinner-border" role="status"><span className="sr-only"></span></div></div>
                    )}
                    {!loading && (
                        <div className="mt-3">
                            <DataTable
                                tableData={invoiceData}
                                TableCols={TransactionInvoicesGridCols}
                                pagination={true}
                                pageCount={pageCount}
                                onSelectPageChange={(e) => onSelectPaginator(e)}
                                onActions={(e) => onActions(e)}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}   